
// 账户中心跳转商户中心的域名地址，会区分开发、测试、生产环境.

export default process.env.VUE_APP_LINK_DOMAIN
